import React from 'react';
import { Switch, Route } from 'library/util/core-router';
import styled from 'styled-components';

import Search from 'apps/hs-planning/pages/search';
import CoursePage from 'apps/hs-planning/pages/course-page';

const StyledHighSchoolPlanningContainer = styled.div`
  width: 100%;
  margin: auto;
  border-top: 1px solid #F0F0F0;
`;

const HighSchoolApp = () => (
  <StyledHighSchoolPlanningContainer>
    <Switch>
      <Route path="/journey/tools/hs-planning" component={Search} exact />
      <Route path="/journey/tools/hs-planning/:course" component={CoursePage} exact />
    </Switch>
  </StyledHighSchoolPlanningContainer>
);

export default HighSchoolApp;
